import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_CONTACT = "GET_LIST_CONTACT";
export const GET_LIST_CONTACT_ERROR = "GET_LIST_CONTACT_ERROR";
export const GET_LIST_CONTACT_SUCCESS = "GET_LIST_CONTACT_SUCCESS";

export const COUNT_LIST_CONTACT = "COUNT_LIST_CONTACT";
export const COUNT_LIST_CONTACT_ERROR = "COUNT_LIST_CONTACT_ERROR";
export const COUNT_LIST_CONTACT_SUCCESS = "COUNT_LIST_CONTACT_SUCCESS";

export const ADD_NEW_CONTACT = "ADD_NEW_CONTACT";
export const ADD_NEW_CONTACT_ERROR = "ADD_NEW_CONTACT_ERROR";
export const ADD_NEW_CONTACT_SUCCESS = "ADD_NEW_CONTACT_SUCCESS";

export const EDIT_A_CONTACT = "EDIT_A_CONTACT";
export const EDIT_A_CONTACT_SUCCESS = "EDIT_A_CONTACT_SUCCESS";
export const EDIT_A_CONTACT_ERROR = "EDIT_A_CONTACT_ERROR";

export const DELETE_A_CONTACT = "DELETE_A_CONTACT";
export const DELETE_A_CONTACT_SUCCESS = "DELETE_A_CONTACT_SUCCESS";
export const DELETE_A_CONTACT_ERROR = "DELETE_A_CONTACT_ERROR";

//contact file
export const GET_LIST_CONTACT_FILE = "GET_LIST_CONTACT_FILE";
export const GET_LIST_CONTACT_FILE_ERROR = "GET_LIST_CONTACT_FILE_ERROR";
export const GET_LIST_CONTACT_FILE_SUCCESS = "GET_LIST_CONTACT_FILE_SUCCESS";

export const COUNT_LIST_CONTACT_FILE = "COUNT_LIST_CONTACT_FILE";
export const COUNT_LIST_CONTACT_FILE_ERROR = "COUNT_LIST_CONTACT_FILE_ERROR";
export const COUNT_LIST_CONTACT_FILE_SUCCESS =
  "COUNT_LIST_CONTACT_FILE_SUCCESS";

export const ADD_NEW_CONTACT_FILE = "ADD_NEW_CONTACT_FILE";
export const ADD_NEW_CONTACT_FILE_ERROR = "ADD_NEW_CONTACT_FILE_ERROR";
export const ADD_NEW_CONTACT_FILE_SUCCESS = "ADD_NEW_CONTACT_FILE_SUCCESS";

export const EDIT_A_CONTACT_FILE = "EDIT_A_CONTACT_FILE";
export const EDIT_A_CONTACT_FILE_SUCCESS = "EDIT_A_CONTACT_FILE_SUCCESS";
export const EDIT_A_CONTACT_FILE_ERROR = "EDIT_A_CONTACT_FILE_ERROR";

export const DELETE_A_CONTACT_FILE = "DELETE_A_CONTACT_FILE";
export const DELETE_A_CONTACT_FILE_SUCCESS = "DELETE_A_CONTACT_FILE_SUCCESS";
export const DELETE_A_CONTACT_FILE_ERROR = "DELETE_A_CONTACT_FILE_ERROR";

export const UPLOAD_CONTACT_FILE = "UPLOAD_CONTACT_FILE";
export const UPLOAD_CONTACT_FILE_SUCCESS = "UPLOAD_CONTACT_FILE_SUCCESS";
export const UPLOAD_CONTACT_FILE_ERROR = "UPLOAD_CONTACT_FILE_ERROR";

export const COUNT_CONTACT_FILE = "COUNT_CONTACT_FILE";
export const COUNT_CONTACT_FILE_SUCCESS = "COUNT_CONTACT_FILE_SUCCESS";
export const COUNT_CONTACT_FILE_ERROR = "COUNT_CONTACT_FILE_ERROR";

//contact detail
export const CONTACT_DETAIL = "CONTACT_DETAIL";
export const CONTACT_DETAIL_SUCCESS = "CONTACT_DETAIL_SUCCESS";
export const CONTACT_DETAIL_ERROR = "CONTACT_DETAIL_ERROR";

/**
 * Reducer
 */

const initialState = {
  contacts: [],
  contactFiles: [],
  error: false,
  count: 0,
  loading: false,
  addDone: false,
};

export const contactsReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_CONTACT:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        contacts: action.payload,
      };
    case GET_LIST_CONTACT_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    //get list
    case GET_LIST_CONTACT_FILE:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_CONTACT_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        contactFiles: action.payload,
      };
    case GET_LIST_CONTACT_FILE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    //count list
    case COUNT_LIST_CONTACT:
      return {
        ...state,
      };
    case COUNT_LIST_CONTACT_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_CONTACT_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //count list
    case COUNT_LIST_CONTACT_FILE:
      return {
        ...state,
      };
    case COUNT_LIST_CONTACT_FILE_SUCCESS:
      return {
        ...state,
        countContactFile: action.payload,
      };
    case COUNT_LIST_CONTACT_FILE_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add new
    case ADD_NEW_CONTACT:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        contact: action.payload,
      };
    case ADD_NEW_CONTACT_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //edit
    case EDIT_A_CONTACT:
      return {
        ...state,
        loading: true,
      };
    case EDIT_A_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        contact: action.payload,
      };
    case EDIT_A_CONTACT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    ///delete
    case DELETE_A_CONTACT:
      return {
        ...state,
        loading: true,
      };
    case DELETE_A_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        contact: action.payload,
      };
    case DELETE_A_CONTACT_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //contact file
    //add new
    case ADD_NEW_CONTACT_FILE:
      return {
        ...state,
        loading: true,
        addDone: false,
      };
    case ADD_NEW_CONTACT_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        contactFile: action.payload,
        addDone: true,
      };
    case ADD_NEW_CONTACT_FILE_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
        addDone: false,
      };
    //edit
    case EDIT_A_CONTACT_FILE:
      return {
        ...state,
        loading: true,
        addDone: false,
      };
    case EDIT_A_CONTACT_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        contactFile: action.payload,
        addDone: true,
      };
    case EDIT_A_CONTACT_FILE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
        addDone: false,
      };
    ///delete
    case DELETE_A_CONTACT_FILE:
      return {
        ...state,
        loading: true,
      };
    case DELETE_A_CONTACT_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        contactFile: action.payload,
      };
    case DELETE_A_CONTACT_FILE_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //upload
    case UPLOAD_CONTACT_FILE:
      return {
        ...state,
        loading: true,
      };
    case UPLOAD_CONTACT_FILE_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    case UPLOAD_CONTACT_FILE_SUCCESS:
      return {
        ...state,
        loading: true,
        fileName: action.files[0],
      };
    //get detail
    case CONTACT_DETAIL:
      return {
        ...state,
        loading: true,
      };
    case CONTACT_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        contact: action.payload,
      };
    case CONTACT_DETAIL_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    //count
    case COUNT_CONTACT_FILE:
      return {
        ...state,
        loading: true,
      };
    case COUNT_CONTACT_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        countContact: action.payload,
      };
    case COUNT_CONTACT_FILE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListContacts = (order, limit, skip, where) => ({
  type: GET_LIST_CONTACT,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const getListContactFile = (order, limit, skip, where) => ({
  type: GET_LIST_CONTACT_FILE,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListContacts = (where) => ({
  type: COUNT_LIST_CONTACT,
  data: {
    where,
  },
});

export const addNewContact = (
  title,
  firstName,
  jobTitle,
  address,
  phoneNumber,
  email,
  gender,
  organization,
  lastName,
  birthday,
  industryId,
  stageId,
  note,
  social,
  website,
  idNumber,
  accountId
) => ({
  type: ADD_NEW_CONTACT,
  data: {
    title,
    firstName,
    jobTitle,
    address,
    phoneNumber,
    email,
    gender,
    organization,
    lastName,
    birthday,
    industryId,
    stageId,
    note,
    social,
    website,
    idNumber,
    accountId,
  },
});

export const editContact = (
  id,
  title,
  firstName,
  jobTitle,
  address,
  phoneNumber,
  email,
  gender,
  organization,
  lastName,
  birthday,
  industryId,
  stageId,
  note,
  social,
  website,
  fullName,
  accountId
) => ({
  type: EDIT_A_CONTACT,
  data: {
    id,
    title,
    firstName,
    jobTitle,
    address,
    phoneNumber,
    email,
    gender,
    organization,
    lastName,
    birthday,
    industryId,
    stageId,
    note,
    social,
    website,
    fullName,
    accountId,
  },
});

export const deleteContact = (id) => ({
  type: DELETE_A_CONTACT,
  data: {
    id,
  },
});
//contact file
export const addNewContactFile = (name, note, fileName) => ({
  type: ADD_NEW_CONTACT_FILE,
  data: {
    name,
    note,
    fileName,
  },
});

export const editContactFile = (id, name, note, fileName) => ({
  type: EDIT_A_CONTACT_FILE,
  data: {
    id,
    name,
    note,
    fileName,
  },
});

export const deleteContactFile = (id) => ({
  type: DELETE_A_CONTACT_FILE,
  data: {
    id,
  },
});

export const uploadContactFile = (files) => ({
  type: UPLOAD_CONTACT_FILE,
  data: {
    files,
  },
});

export const countListContactFile = (where) => ({
  type: COUNT_LIST_CONTACT_FILE,
  data: {
    where,
  },
});

export const getContactDetail = (id) => ({
  type: CONTACT_DETAIL,
  data: {
    id,
  },
});

export const countContactFile = (id, stage) => ({
  type: COUNT_CONTACT_FILE,
  data: {
    id,
    stage,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListContactFile,
      countListContacts,
      addNewContact,
      editContact,
      deleteContact,
      countListContactFile,
      getListContacts,
      addNewContactFile,
      editContactFile,
      deleteContactFile,
      uploadContactFile,
      getContactDetail,
      countContactFile,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListContactsApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/mini-crm/contact", {
    order,
    limit,
    skip,
    ...where,
  });
};

const countListContactsApi = (where) => {
  return apiCaller.getData("/mini-crm/contact/count", { ...where });
};
const addNewContactsApi = (
  title,
  firstName,
  jobTitle,
  address,
  phoneNumber,
  email,
  gender,
  organization,
  lastName,
  birthday,
  industryId,
  stageId,
  note,
  social,
  website,
  idNumber,
  accountId
) => {
  return apiCaller.post("/mini-crm/contact", {
    title,
    firstName,
    jobTitle,
    address,
    phoneNumber,
    email,
    gender,
    organization,
    lastName,
    birthday,
    industryId,
    stageId,
    note,
    social,
    website,
    idNumber,
    accountId,
  });
};
const editContactsApi = (
  id,
  title,
  firstName,
  jobTitle,
  address,
  phoneNumber,
  email,
  gender,
  organization,
  lastName,
  birthday,
  industryId,
  stageId,
  note,
  social,
  website,
  idNumber,
  accountId
) => {
  return apiCaller.put(`/mini-crm/contact/${id}`, {
    title,
    firstName,
    jobTitle,
    address,
    phoneNumber,
    email,
    gender,
    organization,
    lastName,
    birthday,
    industryId,
    stageId,
    note,
    social,
    website,
    idNumber,
    accountId,
  });
};
const deleteContactsApi = (id) => {
  return apiCaller.del(`/mini-crm/contact/${id}`);
};
//contact file
const getListContactsFileApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/mini-crm/contact-file", {
    order,
    limit,
    skip,
    ...where,
  });
};
const countListContactFileApi = (where) => {
  return apiCaller.getData("/mini-crm/contact-file/count", { ...where });
};
const addNewContactsFileApi = (name, note, fileName) => {
  return apiCaller.post("/mini-crm/contact-file", { name, note, fileName });
};
const editContactsFileApi = (id, name, note, fileName) => {
  return apiCaller.put(`/mini-crm/contact-file/${id}`, {
    name,
    note,
    fileName,
  });
};
const deleteContactsFileApi = (id) => {
  return apiCaller.del(`/mini-crm/contact-file/${id}`);
};

const countContactFileApi = (id, stage) => {
  return apiCaller.post(`/mini-crm/contact-file/${id}/count`, [...stage]);
};

const getContactDetailApi = (id) => {
  return apiCaller.getLogs(`/mini-crm/contact/${id}`);
};

/**
 * sagas
 */

export const getListContactsFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_CONTACT);
    try {
      const res = yield call(
        getListContactsApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_LIST_CONTACT_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_LIST_CONTACT_ERROR, error });
    }
  }
};

export const getListContactFileFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_CONTACT_FILE);
    try {
      const res = yield call(
        getListContactsFileApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_LIST_CONTACT_FILE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_CONTACT_FILE_ERROR, error });
    }
  }
};

export const countContactsFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_CONTACT);
    try {
      const res = yield call(countListContactsApi, action.data.where);
      yield put({ type: COUNT_LIST_CONTACT_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: COUNT_LIST_CONTACT_ERROR, error });
    }
  }
};

export const addNewContactsFlow = function* () {
  while (true) {
    const {
      data: {
        title,
        firstName,
        jobTitle,
        address,
        phoneNumber,
        email,
        gender,
        organization,
        lastName,
        birthday,
        industryId,
        stageId,
        note,
        social,
        website,
        idNumber,
        accountId,
      },
    } = yield take(ADD_NEW_CONTACT);
    try {
      const res = yield call(
        addNewContactsApi,
        title,
        firstName,
        jobTitle,
        address,
        phoneNumber,
        email,
        gender,
        organization,
        lastName,
        birthday,
        industryId,
        stageId,
        note,
        social,
        website,
        idNumber,
        accountId
      );
      yield put({ type: ADD_NEW_CONTACT_SUCCESS, payload: { ...res.data } });
      // const history = globalHistory();
      // history.replace(`${process.env.REACT_APP_PATH}/contact-center/contact`);
    } catch (error) {
      yield put({ type: ADD_NEW_CONTACT_ERROR, error });
    }
  }
};

export const editContactsFlow = function* () {
  while (true) {
    const {
      data: {
        id,
        title,
        firstName,
        jobTitle,
        address,
        phoneNumber,
        email,
        gender,
        organization,
        lastName,
        birthday,
        industryId,
        stageId,
        note,
        social,
        website,
        fullName,
        accountId,
      },
    } = yield take(EDIT_A_CONTACT);
    try {
      const res = yield call(
        editContactsApi,
        id,
        title,
        firstName,
        jobTitle,
        address,
        phoneNumber,
        email,
        gender,
        organization,
        lastName,
        birthday,
        industryId,
        stageId,
        note,
        social,
        website,
        fullName,
        accountId
      );
      yield put({ type: EDIT_A_CONTACT_SUCCESS, payload: { ...res.data } });
      // const history = globalHistory();
      // history.replace(`${process.env.REACT_APP_PATH}/contact-center/contact`);
    } catch (error) {
      yield put({ type: EDIT_A_CONTACT_ERROR, error });
    }
  }
};

export const deleteContactsFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_CONTACT);
    try {
      const res = yield call(deleteContactsApi, action.data.id);
      yield put({ type: DELETE_A_CONTACT_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: DELETE_A_CONTACT_ERROR, error });
    }
  }
};

//contact file
export const addNewContactsFileFlow = function* () {
  while (true) {
    const action = yield take(ADD_NEW_CONTACT_FILE);
    try {
      const res = yield call(
        addNewContactsFileApi,
        action.data.name,
        action.data.note,
        action.data.fileName
      );
      yield put({ type: ADD_NEW_CONTACT_FILE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: ADD_NEW_CONTACT_FILE_ERROR, error });
    }
  }
};

export const editContactsFileFlow = function* () {
  while (true) {
    const action = yield take(EDIT_A_CONTACT_FILE);
    try {
      const res = yield call(
        editContactsFileApi,
        action.data.id,
        action.data.name,
        action.data.note,
        action.data.fileName
      );
      yield put({
        type: EDIT_A_CONTACT_FILE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: EDIT_A_CONTACT_FILE_ERROR, error });
    }
  }
};

export const deleteContactsFileFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_CONTACT_FILE);
    try {
      const res = yield call(deleteContactsFileApi, action.data.id);
      yield put({
        type: DELETE_A_CONTACT_FILE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: DELETE_A_CONTACT_FILE_ERROR, error });
    }
  }
};

export const countListContactFileFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_CONTACT_FILE);
    try {
      const res = yield call(countListContactFileApi, action.data.where);
      yield put({
        type: COUNT_LIST_CONTACT_FILE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_CONTACT_FILE_ERROR, error });
    }
  }
};

export const getContactDetailFlow = function* () {
  while (true) {
    const action = yield take(CONTACT_DETAIL);
    if (action.data.id) {
      try {
        const contactDetail = yield call(getContactDetailApi, action.data.id);
        if (contactDetail.data) {
          yield put({
            type: CONTACT_DETAIL_SUCCESS,
            payload: { ...contactDetail.data },
          });
        }
      } catch (error) {
        yield put({ type: CONTACT_DETAIL_ERROR, error });
      }
    } else {
      yield put({ type: CONTACT_DETAIL_ERROR });
    }
  }
};

export const countContactFileFlow = function* () {
  while (true) {
    const action = yield take(COUNT_CONTACT_FILE);
    try {
      const res = yield call(
        countContactFileApi,
        action.data.id,
        action.data.stage
      );
      yield put({ type: COUNT_CONTACT_FILE_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: COUNT_CONTACT_FILE_ERROR, error });
    }
  }
};
